import { post } from '../tools/http';

const api = {
    startSurvey: ({ surveyId, singleResult, returnUrl = null, mentoringRole }) => {
        let type = 'survey';
        if (returnUrl) {
            return post(
                'examination',
                `sessions/${type}/${surveyId}/start?single_result=${singleResult}`,
                {
                    returnUrl,
                    channel: "mentoringRequest",
                    meta: {
                        mentoringRole,
                    },
                },
                true
            );
        } else {
            return post(
                'examination',
                `sessions/${type}/${surveyId}/start?single_result=${singleResult}`,
                {
                    channel: "mentoringRequest",
                    meta: {
                        mentoringRole,
                    },
                },
                true
            );
        }
    },
};

export default {
    actions: {
        async startSurvey(ctx, { surveyId, singleResult, returnUrl, mentoringRole }) {
            const res = await api.startSurvey({ surveyId, singleResult, returnUrl, mentoringRole });
            if (!res) {
                return null;
            }
            return  res.redirectUrl;
        },
    },
};
